module.exports = __webpack_public_path__ + "img/euro.2f215ac2.svg";